import { createStore, combineReducers } from 'redux'

let traceRedux = false
if (process.env.NODE_ENV === 'production') {
  traceRedux = false
}

const reduxReducerKey = '@@@@@reducerKey'
const reduxObjectToMergeKey = '@@@@@objectToMergeKey'
const nullReducer = '@@@@@nullReducer'

// This is from redux docs.
// https://redux.js.org/recipes/code-splitting

// The purpose of the code below is to allow dynamically added reducers.

let staticReducers = {}

const createReducer = asyncReducers => {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers
  })
}

// Configure the store
const configureStore = (initialReducers = {}, initialState, enhancer) => {
  if (Object.keys(initialReducers).length === 0) {
    initialReducers[nullReducer.toString()] = (state = {}) => state
  }
  staticReducers = { ...initialReducers }
  const store = createStore(createReducer(), initialState, enhancer)

  // Add a dictionary to keep track of the registered async reducers
  store.asyncReducers = {}

  // Create an inject reducer function
  // This function adds the async reducer, and creates a new combined reducer
  store.injectReducer = (key, asyncReducer) => {
    store.asyncReducers[key.toString()] = asyncReducer
    store.replaceReducer(createReducer(store.asyncReducers))
  }

  extendStore(store)

  // Return the modified store
  return store
}

const extendStore = reduxStore => {
  reduxStore.setRState = makeSetRState(reduxStore)
  reduxStore.getRState = makeGetRState(reduxStore)
  reduxStore.addReducer = addReducer
}

const makeSetRState = reduxStore => {
  return (reducerKey, objToMerge, reduceKeyType) => {
    let type = reduceKeyType
    if (type === undefined) {
      type = reducerKey
    }
    if (traceRedux) {
      // eslint-disable-next-line no-console
      console.log('reduxStore.dispatch start', reduxReducerKey, reduxObjectToMergeKey, reducerKey, type, new Date().getTime())
    }
    reduxStore.dispatch({
      [reduxReducerKey]: reducerKey,
      [reduxObjectToMergeKey]: objToMerge,
      type
    })
    if (traceRedux) {
      // eslint-disable-next-line no-console
      console.log('reduxStore.dispatch end', reducerKey, new Date().getTime())
    }
  }
}

const makeGetRState = reduxStore => {
  return reducerKey => {
    if (traceRedux) {
      // eslint-disable-next-line no-console
      console.log('reduxStore.getState start', reducerKey, new Date().getTime())
    }
    const state = reduxStore.getState()[reducerKey.toString()] 
    if (traceRedux) {
      // eslint-disable-next-line no-console
      console.log('reduxStore.getState end', reducerKey, new Date().getTime())
    }
    return state
  }
}

const addReducer = (store, reducerKey, initialState) => {
  const reducer = generateReducer(reducerKey, initialState)
  store.injectReducer(reducerKey, reducer)
}

//
// Call this to generate your reducer.
//
const generateReducer = (reducerKey, initialStateData) => {
  const initialState = { ...initialStateData }
  return (state = initialState, action) => {
    if (action[reduxReducerKey.toString()] === reducerKey) {
      return { ...state, ...action[reduxObjectToMergeKey.toString()] }
    }
    return state
  }
}

export default configureStore
